import { Link } from 'react-router-dom'

import { LogoLight } from '@/assets/svg'
import { FacebookIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from '@/assets/svg/social-icons'

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner container">
        <div className="footer-main">
          <Link to="/" className="footer-logo">
            <img src={LogoLight} alt="Bright.source" />
          </Link>

          <div className="footer-links">
            <Link to="/">Startup jobs</Link>
            <Link to="/terms-of-use">Terms of use</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>

          <div className="footer-socials">
            {/* Facebook/Twitter/YouTube were `class="disabled" href="/"` in legacy — no real
                destination exists. Rendered as spans: same muted look, but a control that goes
                nowhere is not clickable at all. */}
            <span className="disabled">
              <FacebookIcon />
            </span>
            <a
              href="https://il.linkedin.com/company/brightsource-data-analytics"
              aria-label="BrightSource on LinkedIn"
            >
              <LinkedinIcon />
            </a>
            <span className="disabled">
              <TwitterIcon />
            </span>
            <span className="disabled">
              <YoutubeIcon />
            </span>
          </div>
        </div>

        <p className="footer-copyright">Copyright © 2023. All rights reserved.</p>
      </div>
    </footer>
  )
}
